import React, { useState } from "react";
import { CForm, CButton, CCard, CCardBody } from "@coreui/react";
import LoadingOverlay from "react-loading-overlay";

import { resevationForm } from "forms/reservation";
import CustomInput from "components/CustomInput";
import CustomCheckbox from "components/CustomCheckbok";
import CustomSelect from "components/CustomSelect";
import { maritalStatus } from "constants/maritalStatus";

import Symptoms from "../Symptoms";

import { useReservation } from "context/reservationContext";

function FormAssistant({
  onBlurNumberId,
  onBlurTypeId,
  loading,
  currentAssistant,
  handleSubmit,
  errors,
  control,
  register,
  onBlurNewFields,
  showNewFields,
}) {
  const { handleAddAssistant, handleEditAssistant, assistants, setShowTable } =
    useReservation();

  const [modal, setModal] = useState(false);
  const onSubmit = currentAssistant ? handleEditAssistant : handleAddAssistant;
  const symptomsCheck = { text: "Ver síntomas", func: () => setModal(true) };
  const politic = {
    text: "política de tratamiento de datos.",
    func: () =>
      window.open(
        "https://firebasestorage.googleapis.com/v0/b/elcamino-97306.appspot.com/o/POLITICA%20TRATAMIENTO%20DE%20DATOS.pdf?alt=media&token=60fcde90-6fb2-4166-bd5a-cc2ea1b1bed6",
        "_blank"
      ),
  };
  const date = new Date();

  const getDefault = (name) => {
    if (currentAssistant && currentAssistant[name])
      return currentAssistant[name];
    return "";
  };

  return (
    <LoadingOverlay active={loading} spinner text="Cargando...">
      <CForm className="form-horizontal">
        <hr></hr>
        <p>
          <b>Complete la siguiente información</b>
        </p>
        {resevationForm.textInputs.map((input) =>
          input.type === "select" ? (
            input.name === "typeId" ? (
              <CustomSelect
                name={input.name}
                placeholder={input.label}
                control={control}
                errors={errors}
                required={input.required}
                key={input.name}
                options={input.options}
                defaultValue={getDefault(input.name)}
                onSelect={onBlurTypeId}
              />
            ) : input.name === "first" ? (
              <CustomSelect
                name={input.name}
                placeholder={input.label}
                control={control}
                errors={errors}
                required={input.required}
                key={input.name}
                options={input.options}
                defaultValue={getDefault(input.name)}
                onSelect={onBlurNewFields}
              />
            ) : (
              <CustomSelect
                name={input.name}
                placeholder={input.label}
                control={control}
                errors={errors}
                required={input.required}
                key={input.name}
                options={input.options}
                defaultValue={getDefault(input.name)}
              />
            )
          ) : input.name === "numberId" ? (
            <CustomInput
              name={input.name}
              placeholder={input.label}
              control={control}
              errors={errors}
              required={input.required}
              type={input.type || "text"}
              key={input.name}
              defaultValue={getDefault(input.name)}
              onBlur={onBlurNumberId}
              register={register}
            />
          ) : input.name === "birthday" ? (
            <CustomInput
              name={input.name}
              placeholder={input.label}
              control={control}
              errors={errors}
              required={input.required}
              type={input.type || "text"}
              key={input.name}
              defaultValue={getDefault(input.name)}
              register={register}
              max={date.toISOString().substring(0, 10)}
            />
          ) : (
            <CustomInput
              name={input.name}
              placeholder={input.label}
              control={control}
              errors={errors}
              required={input.required}
              type={input.type || "text"}
              key={input.name}
              defaultValue={getDefault(input.name)}
              register={register}
            />
          )
        )}
        {showNewFields && (
          <>
            <CustomInput
              name="city"
              placeholder="Ciudad"
              control={control}
              errors={errors}
              type="text"
              key="city"
              register={register}
              required={showNewFields}
            />
            <CustomInput
              name="neighborhood"
              placeholder="Barrio"
              control={control}
              errors={errors}
              type="text"
              key="neighborhood"
              register={register}
              required={showNewFields}
            />
            <CustomSelect
              name="maritalStatus"
              placeholder="Estado civil"
              control={control}
              errors={errors}
              key="maritalStatus"
              options={maritalStatus}
              defaultValue={maritalStatus[0].value}
              required={showNewFields}
            />
            <CustomInput
              name="prayRequest"
              placeholder="Petición de oración"
              control={control}
              errors={errors}
              type="text"
              key="prayRequest"
              register={register}
              required={showNewFields}
            />
          </>
        )}
        <CustomCheckbox
          name="covid"
          placeholder="Declaro no tener, ni haber tenido síntomas asociados al COVID-19 y no haber estado en contacto con personas con síntomas asociados COVID-19 en los últimos 15 días."
          control={control}
          errors={errors}
          defaultValue={getDefault("covid")}
          link={symptomsCheck}
        />
        <Symptoms show={modal} onClose={() => setModal(false)} />
        <CustomCheckbox
          name="termins"
          placeholder="Acepto estar de acuerdo con  la "
          control={control}
          errors={errors}
          required
          defaultValue={getDefault("termins")}
          link={politic}
        />
        <CCard color="light">
          <CCardBody>
            Si asistes con tu familia o personas que vivan bajo el mismo techo,
            debes registrar cada miembro, desde el más pequeño hasta el más
            adulto. El acceso para todos será con el mismo QR, por lo tanto,
            deben estar juntos al ingresar a la iglesia.
          </CCardBody>
        </CCard>
        <CButton onClick={handleSubmit(onSubmit)} size="sm" color="primary">
          {currentAssistant ? "Actualizar asistente" : "Agregar asistente"}
        </CButton>
        {assistants.length > 0 && (
          <CButton onClick={() => setShowTable(true)} size="sm" color="danger">
            Cancelar
          </CButton>
        )}
      </CForm>
    </LoadingOverlay>
  );
}

export default FormAssistant;
